import { render, staticRenderFns } from "./login.vue?vue&type=template&id=17681d67&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "@/styles/wap.scss?vue&type=style&index=0&id=17681d67&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17681d67",
  null
  
)

export default component.exports